import { DesktopHeader } from './components/DesktopHeader'
import { HeaderWrapper } from './components/HeaderWrapper'
import { MobileHeader } from './components/MobileHeader'
import { NoAccessUserMenu } from './components/UserMenu/NoAccessUserMenu'

export const NoAccessHeader = () => (
  <HeaderWrapper>
    <DesktopHeader>
      <NoAccessUserMenu />
    </DesktopHeader>
    <MobileHeader>
      <NoAccessUserMenu />
    </MobileHeader>
  </HeaderWrapper>
)
